import React from 'react';
import PropTypes from 'prop-types';
import ProjectItem from '@components/ProjectItem';
import ScrollToNext from '@components/ScrollToNext';
import projectItems from './project-items';

import './style.scss';

const ProjectPage = (props, context) => {
  const {
    theme: { colorPrimary, colorAlternate, bgPrimary }
  } = context;

  return (
    <div className="project-page" style={{ backgroundColor: bgPrimary }}>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>Projects</h1>
        <div className="project-wrapper">
          <style jsx="true">
            {`
              .project-item {
                background-color: ${colorAlternate};
                color: ${colorPrimary};
             ; }
              .project-item a {
                color: ${colorPrimary};
              }
              .project-item__links a:hover {
                border-bottom: 2px solid ${colorPrimary};
              }
            `}
          </style>
          {/* <ProjectItem /> */}
          {projectItems.map((item, i) => (
            <ProjectItem {...item} key={i}/>
          ))}
        </div>
      </div>
      <ScrollToNext pageSelector=".misc-page" />
    </div>
  );
};

ProjectPage.contextTypes = {
  theme: PropTypes.any
};

export default ProjectPage;



// WEBPACK FOOTER //
// ./src/pages/ProjectPage/ProjectPage.js